import { differenceInDays } from 'date-fns';

export const getDateDiffFromDateToDate = (dateEnd: Date, dateStart: Date) => {
  return differenceInDays(dateEnd, dateStart);
};

export const getDateDiffFromNow = (dateEnd: Date) => {
  const today = new Date();
  return differenceInDays(dateEnd, today);
};
